module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"management_philosophy":"経営理念","vision_and_future":"ビジョン・共に創りたい未来","message":"メッセージ","school_memo":"学校からの共有・補足"}}')
  delete Component.options._Ctor
}
